import { render, staticRenderFns } from "./category-favourite-filter.vue?vue&type=template&id=001ce8e8&"
import script from "./category-favourite-filter.vue.ts?vue&type=script&lang=ts&"
export * from "./category-favourite-filter.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports